export interface StatusBadgeProps {
  status: string;
  type?: 'project' | 'upload' | 'invitation';
  label?: string;
}

const STATUS_STYLES: Record<string, string> = {
  awaiting_upload: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
  in_review: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
  active: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
  uploading: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
  complete: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
  completed: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
  accepted: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
  archived: 'bg-gray-100 text-gray-700 dark:bg-gray-700/40 dark:text-gray-300',
  expired: 'bg-gray-100 text-gray-700 dark:bg-gray-700/40 dark:text-gray-300',
  aborted: 'bg-gray-100 text-gray-700 dark:bg-gray-700/40 dark:text-gray-300',
  cancelled: 'bg-gray-100 text-gray-700 dark:bg-gray-700/40 dark:text-gray-300',
  failed: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
  pending: 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300',
  deleted: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
  admin: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
  leadership: 'bg-violet-100 text-violet-800 dark:bg-violet-900/30 dark:text-violet-300',
  employee: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
};

const STATUS_LABELS: Record<string, string> = {
  awaiting_upload: 'Awaiting Upload',
  in_review: 'In Review',
};

const DEFAULT_STYLE = 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300';

function getStatusLabel(status: string): string {
  const normalized = status.toLowerCase();
  if (STATUS_LABELS[normalized]) return STATUS_LABELS[normalized];
  return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function StatusBadge({ status, type: _type, label }: StatusBadgeProps) {
  const normalizedStatus = status.toLowerCase();
  const style = STATUS_STYLES[normalizedStatus] ?? DEFAULT_STYLE;

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${style}`}
    >
      {label || getStatusLabel(status)}
    </span>
  );
}
